import gql from 'graphql-tag';

const query = gql`
  mutation signConsent($params: ConsentInput!) {
    signConsent(params: $params)
  }
`;

export default query;
